module.exports = __webpack_public_path__ + "files/72884216fbcc7a513b540be011ae807d.png";